import { defineStore } from 'pinia'
import { FetchUtils } from '@/utils/web/client/fetch-client.js'
import { setYtbUnauthorizedHandler } from '@/views/corp/ytb/lib/ytb-access.js'

const API_STATUS = '/api/ytb/access/status'
const API_UNLOCK = '/api/ytb/unlock'

export const useYtbAccessStore = defineStore('ytbAccess', {
  state: () => ({
    checked: false,
    authorized: false,
    expiresAt: null,
    dialogVisible: false,
    unlocking: false,
    unlockError: '',
  }),

  actions: {
    init() {
      setYtbUnauthorizedHandler(() => this.onUnauthorized())
    },

    onUnauthorized() {
      this.authorized = false
      this.checked = true
      if (this._needsGateOnRoute()) {
        this.dialogVisible = true
      }
    },

    syncDialogForRoute(route) {
      if (!route?.meta?.ytbAccess) {
        this.dialogVisible = false
        return
      }
      this.dialogVisible = this.checked && !this.authorized
    },

    async ensureForSubPage(route) {
      if (!route?.meta?.ytbAccess) {
        this.dialogVisible = false
        return true
      }
      if (!this.checked) {
        await this.fetchStatus()
      }
      this.syncDialogForRoute(route)
      return this.authorized
    },

    async fetchStatus() {
      const data = await FetchUtils.requestAppData(API_STATUS)
      this.authorized = !!data?.authorized
      this.expiresAt = data?.expiresAt ?? null
      this.checked = true
      this.syncDialogForRoute({ meta: { ytbAccess: this._needsGateOnRoute() } })
      return this.authorized
    },

    async unlock(password) {
      const val = String(password || '').trim()
      if (!val) {
        this.unlockError = '请输入密码'
        return false
      }
      this.unlocking = true
      this.unlockError = ''
      try {
        const data = await FetchUtils.requestAppData(API_UNLOCK, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ password: val }),
        })
        this.authorized = !!data?.authorized
        this.expiresAt = data?.expiresAt ?? null
        this.checked = true
        this.dialogVisible = false
        return true
      } catch (e) {
        this.unlockError = e?.message || '解锁失败'
        return false
      } finally {
        this.unlocking = false
      }
    },

    _needsGateOnRoute() {
      if (typeof window === 'undefined') return false
      const path = window.location.pathname
      if (path === '/ytb' || path === '/ytb/') return false
      return path.startsWith('/ytb/')
    },
  },
})
